'use strict';
//global

import dispatcher from '../dispatcher';
import {EventEmitter} from '../utils';


const eventEmitter = new EventEmitter();
const forcedEventEmitter = new EventEmitter();

let initialized = false;
let size = {
  width: 0,
  height: 0,
  grad: 0
};

let disabled = false;

function _windowSize() {
  let width = 0, height = 0;
  if (document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight )) {
    width = document.documentElement.clientWidth;
    height = document.documentElement.clientHeight;
  } else if (typeof( window.innerWidth ) === 'number') {
    // console.dir(window);
    width = window.innerWidth;
    height = window.innerHeight;
  } else if (document.body && ( document.body.clientWidth || document.body.clientHeight )) {
    width = document.body.clientWidth;
    height = document.body.clientHeight;
  }
  return {
    height: height,
    width: width
  }
}


function _change() {
  size = _windowSize();


  let screenOrientation = window.screen.orientation || window.screen.mozOrientation || window.screen.msOrientation;
  let windowOrientation = window.orientation;

  if (screenOrientation) {
    if (screenOrientation.type === 'landscape-primary') {
      size.grad = -90;
    } else if (screenOrientation.type === 'landscape-secondary') {
      size.grad = 90;
    } else if (screenOrientation.type === 'portrait-primary') {
      size.grad = 0;
    } else if (screenOrientation.type === 'portrait-secondary') {
      size.grad = 180;
    }
  } else if (windowOrientation) {
    size.grad = windowOrientation;
  } else {
    if (size.width > size.height) {
      size.grad = 90;
    } else {
      size.grad = 0;
    }
  }

  forcedEventEmitter.dispatch(_getData('change'));

  if (!disabled) eventEmitter.dispatch(_getData('change'));
}


function _handleEvent(e) {
  if (e.type === 'fire-resize') _change();
  if (e.type === 'resize-disable') disabled = true;
  if (e.type === 'resize-enable') disabled = false;
}


function _getData(type) {
  return {
    type: type,
    _module: 'resize.store',
    height: size.height,
    width: size.width,
    grad: size.grad
  };
}

if (!initialized) _init();


function _init() {
  size = _windowSize();

  window.addEventListener('resize', _change, false);
  window.addEventListener('orientationchange', _change, false);
  window.addEventListener('load', _change, false);

  dispatcher.subscribe(_handleEvent);
  initialized = true;
}


export default {
  eventEmitter: eventEmitter,
  forcedEventEmitter: forcedEventEmitter,
  getData: _getData.bind(null, undefined)
};